function summaryEvenHeight(item) {
    const breakpoint = 992;
    const summaries = item.querySelectorAll('.comparison-table-summary-list');
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

    // Remove set height
    summaries.forEach((summary) => {
        summary.style.height = 'auto';
    });

    // Make summaries same height when side by side
    if (viewportWidth >= breakpoint) {
        const heights = [...summaries].map((item) => item.getBoundingClientRect().height);
        const height = Math.max(...heights);

        summaries.forEach((summary) => {
            summary.style.height = `${height}px`;
        });
    }
}

function setContentHeight(container, content, isCollapsed) {
    container.style.height = isCollapsed ? 0 : `${content.getBoundingClientRect().height}px`;
}

function collapsibleElement(item) {
    const collapsedClass = 'collapsed';
    const container = item.querySelector('.comparison-table-container');
    const toggleBtn = item.querySelector('.comparison-table-toggle-button');
    const content = item.querySelector('.comparison-table-content-container');
    const collapsible = item.querySelector('.comparison-table-collapsible');

    // Collapse or expand on click
    toggleBtn.addEventListener('click', (event) => {
        container.classList.toggle(collapsedClass);
        setContentHeight(collapsible, content, container.classList.contains(collapsedClass));
    });

    // Make summaries same height and set content height
    summaryEvenHeight(item);
    setContentHeight(collapsible, content, container.classList.contains(collapsedClass));

    // Adjust sizes on window resize
    window.addEventListener('resize', (event) => {
        // Make summaries same height and set content height
        summaryEvenHeight(item);
        setContentHeight(collapsible, content, container.classList.contains(collapsedClass));
    });
}

export function comparisonTableInit() {
    const items = document.querySelectorAll('.comparison-table-block');

    items.forEach((item) => {
        collapsibleElement(item);
    });
};



// WEBPACK FOOTER //
// ./src/js/comparison-table.js